import {PlainDtoModel} from '../../../../../common/entity/dto/plain/plainDto.model';
import {FormDefinitionFieldModel} from '../../../../definition/field/api/entity/formDefinitionField.model';
import {DocumentSummaryModel} from '../../../../../document/common/api/model/documentSummary.model';

export class FormValueModel implements PlainDtoModel {
    value: any;
    fieldDefinition: FormDefinitionFieldModel;
    label: string;
    id: number;
    comment: string;
    document: DocumentSummaryModel;
}
